import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {ReactiveFormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TranslatePipe} from '@ngx-translate/core';
import {AttachmentType, getSelectableAttachmentTypes} from '../../../../models/antrag-ticket/AttachmentType';
import {SafeHtmlPipe} from '../../../../shared/pipes/safe-html.pipe';
import {TextareaComponent} from '../../../../shared/form/textarea/textarea.component';
import {
  TicketAntragSidebarAttachmentsComponent
} from '../sidebar/ticket-antrag-sidebar-attachments/ticket-antrag-sidebar-attachments.component';

@Component({
  selector: 'app-sonderfall-multi-select',
  templateUrl: './sonderfall-multi-select.component.html',
  styleUrl: './sonderfall-multi-select.component.scss',
  standalone: true,
  imports: [
    NgClass,
    ReactiveFormsModule,
    FaIconComponent,
    TranslatePipe,
    SafeHtmlPipe,
    TextareaComponent,
    TicketAntragSidebarAttachmentsComponent
  ]
})
export class SonderfallMultiSelectComponent {

  @Input() formArray: UntypedFormArray;
  @Input() options: { value: string; name: string; info?: string }[] = [];
  @Input() antragTicketId: string;
  @Input() readonly = false;
  @Input() deleteable = false;
  @Input() appendable = false;
  @Input() nachweisRequiredFor: string[] = [];
  @Input() label: string;
  @Input() infoText: string;
  @Input() begruendungLabel: string;
  @Input() allowedTypesForSelection: AttachmentType[] = getSelectableAttachmentTypes();

  faInfo = faInfoCircle;
  protected readonly AttachmentType = AttachmentType;

  constructor(private readonly fb: UntypedFormBuilder) {
  }

  isSelected(value: string): boolean {
    return this.formArray?.controls?.some(control => control.get('sonderfall')?.value === value) ?? false;
  }

  getEntry(value: string): UntypedFormGroup {
    return this.formArray?.controls?.find(control => control.get('sonderfall')?.value === value) as UntypedFormGroup;
  }

  isSonstiges(value: string): boolean {
    return value === 'SONSTIGES';
  }

  /** Whether a SONDERFALLNACHWEIS upload is mandatory for this Sonderfall (see plan §5). */
  isNachweisRequired(value: string): boolean {
    return this.nachweisRequiredFor.includes(value);
  }

  toggle(value: string, checked: boolean): void {
    if (this.readonly || !this.formArray) {
      return;
    }
    if (checked) {
      if (!this.isSelected(value)) {
        this.formArray.push(this.fb.group({
          id: [null],
          sonderfall: [value],
          begruendung: [null]
        }));
      }
    } else {
      const index = this.formArray.controls.findIndex(control => control.get('sonderfall')?.value === value);
      if (index > -1) {
        this.formArray.removeAt(index);
      }
    }
    this.formArray.markAsDirty();
  }
}
